/** Keep in sync with backend `DEFAULT_CHECK_IN_WELCOME_TEMPLATE` (checkInWelcomeTemplate.ts). */
export const DEFAULT_CHECK_IN_WELCOME_TEMPLATE =
  "Welcome to {{hotel_name}}, {{guest_name}}! We're delighted you're here. " +
  "Your room is {{room_number}}. If you need anything—towels, dining ideas, or a quiet moment—just reply on WhatsApp and we'll take care of it. Enjoy your stay!";
